
import { manualNavStateType } from 'reducer/types'; 

  export const SET_MANUAL_NAV_STATE = (payload: manualNavStateType) => ({
    type: 'SET_MANUAL_NAV_STATE',
    payload: payload
  });  
